<template>
  <a-spin :spinning="spinning">
    <!-- <react-table
      :table-data="tableData"
      :total-items="totalItems"
      :showTotal="showTotalFun"
      :actions-type="actionsType"
      :columns="columns"
      :scroll="{ x: 1200 }"
      :hide-row-selection="true"
      :current-page="pageNumber"
      @emitRefreshData="clearFilterAndRefresh"
      @emitSortData="updateSortData"
      @emitSelectChange="updateSelectChange"
      @emitOnPageChange="updatePageChange"
      @emitShowSizeChange="updateShowSizeChange"
    > -->
    <ele-table
      :columns="columns"
      :table-data="tableData"
      :total-items="totalItems"
      :is-full="false"
      :actionsType="actionsType"
      :current-page="pageNumber"
      :hide-row-selection="true"
      @emitRefreshData="clearFilterAndRefresh"
      @emitSelectChange="updateSelectChange"
      @emitOnPageChange="updatePageChange"
      @emitShowSizeChange="updateShowSizeChange"
    >
      <a-row
        :gutter="8"
        class=""
        type="flex"
        align="middle"
        justify="space-between"
      >
        <a-col :span="12">
          <a-input-search
            name="filterText"
            @search="changeFilterText()"
            :placeholder="l('SearchWithThreeDot')"
            enterButton
            v-model="filterText"
          />
        </a-col>
        <a-col :span="8" :offset="4" align="right">
          <a @click="createOrEdit(null, 'create')">
            <a-icon type="plus" /> {{ l("添加") }}
          </a>
          <a-divider type="vertical"></a-divider>
          <a :title="l('Refresh')" @click="clearFilterAndRefresh()">
            <a-icon type="reload"
          /></a>
        </a-col>
      </a-row>
    </ele-table>
  </a-spin>
</template>

<script>
import { AppComponentBase } from "@/shared/component-base";
import { CommonServiceProxy } from "@/shared/common-service";
import { ModalHelper } from "@/shared/helpers";
import EleTable from "@/components/ele-table";
import ReactModify from "@/components/react-modify";
import moment from "moment";

export default {
  name: "real-name",
  mixins: [AppComponentBase],
  props: ["id", "tableKey"],
  components: { EleTable },
  data() {
    return {
      spinning: false,
      commonService: null,
      selectedRowKeys: [],
      name: "",
      filterText: "",
      // 总数
      totalItems: 0,
      // 当前页码
      pageNumber: 1,
      // 共多少页
      totalPages: 1,
      // 条数显示范围
      pagerange: [1, 1],
      // 显示条数
      pageSizeOptions: ["10", "20", "30", "40"],
      request: { sorting: "", maxResultCount: 50, skipCount: 0 },
      // 用户表格
      columns: [
        // {
        //   title: this.l("税收分类编码"),
        //   dataIndex: "taxCategoryCode",
        //   sorter: true,
        //   align: "center",
        //   scopedSlots: { customRender: "taxCategoryCode" },
        // },
        {
          title: this.l("税收分类名称"),
          dataIndex: "taxCategoryName",
          sorter: true,
          align: "center",
          fixed: "left",
          width: 180,
          scopedSlots: { customRender: "taxCategoryName" },
        },
        {
          title: this.l("税率"),
          dataIndex: "taxRate",
          sorter: true,
          align: "center",
          scopedSlots: { customRender: "taxRate" },
        },
        {
          title: this.l("产品编码"),
          dataIndex: "productCode",
          sorter: true,
          align: "center",
          scopedSlots: { customRender: "productCode" },
        },
        {
          title: this.l("产品名称"),
          dataIndex: "productName",
          sorter: true,
          align: "center",
          scopedSlots: { customRender: "productName" },
        },
        // {
        //   title: this.l("发票类型"),
        //   dataIndex: "invoiceType",
        //   sorter: true,
        //   align: "center",
        //   scopedSlots: { customRender: "invoiceType" },
        // },
        {
          title: this.l("发票类型"),
          dataIndex: "invoiceTypeName",
          sorter: true,
          align: "center",
          scopedSlots: { customRender: "invoiceTypeName" },
        },
        {
          title: this.l("创建时间"),
          dataIndex: "creationTimeDesc",
          sorter: true,
          align: "center",
          scopedSlots: { customRender: "creationTimeDesc" },
        },
        {
          title: this.l("更新时间"),
          dataIndex: "lastModificationTimeDesc",
          sorter: true,
          align: "center",
          scopedSlots: { customRender: "lastModificationTimeDesc" },
        },
        {
          title: this.l("Actions"),
          dataIndex: "actions",
          sorter: true,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "actions" },
        },
      ],
      selectOptions: [],
      // 用户数据
      tableData: [],
      actionsType: {},
      getDataParams: [],
      changeOpt: [],
    };
  },
  computed: {},
  created() {
    this.commonService = new CommonServiceProxy(this.$apiUrl, this.$api);
    this.initActionsType();
  },
  mounted() {},
  methods: {
    // 拉取数据
    async getData(opt, url) {
      this.spinning = true;
      let params = {
        organizationUnitId: this.id,
        filterText: this.filterText,
        sorting: this.request.sorting,
        skipCount: this.request.skipCount,
        maxResultCount: this.request.maxResultCount,
      };
      if (opt && opt.length) {
        if (!this.getDataParams.length) this.getDataParams = opt;
        opt.map((it) => {
          if (it.key && it.value) {
            params[it.key] = it.value;
          }
        });
      } else if (this.getDataParams && this.getDataParams.length) {
        this.getDataParams.map((it) => {
          if (it.key && it.value) {
            params[it.key] = it.value;
          }
        });
      }
      this.changeOpt = opt;
      try {
        let res = await this.commonService.get({
          url: "/api/services/app/InvoiceInformational/GetPaged",
          params: params,
        });
        this.tableData = res.items.map((o) => {
          return {
            ...o,
            creationTimeDesc: o.creationTime
              ? moment(o.creationTime).format("YYYY-MM-DD hh:mm")
              : "-",
            lastModificationTimeDesc: o.lastModificationTime
              ? moment(o.lastModificationTime).format("YYYY-MM-DD hh:mm")
              : "-",
          };
        });
        this.totalItems = res.totalCount;
        this.pagerange = [
          (this.pageNumber - 1) * this.request.maxResultCount + 1,
          this.pageNumber * this.request.maxResultCount,
        ];
        this.totalPages = Math.ceil(
          res.totalCount / this.request.maxResultCount
        );
        this.spinning = false;
      } catch (error) {
        this.spinning = false;
      }
    },
    changeFilterText() {
      this.request.skipCount = 0;
      this.getData(this.changeOpt);
    },
    getStatus(type) {
      switch (type) {
        case 0:
          return "未认证";
          break;
        case 1:
          return "管理员资料已提交";
          break;
        case 2:
          return "企业基本资料(没有申请表)已提交";
          break;
        case 3:
          return "已提交待审核";
          break;
        case 4:
          return "审核通过";
          break;
        case 5:
          return "审核不通过";
          break;
        case 6:
          return "人工初审通过";
          break;
        default:
          return "-";
      }
    },
    // 清除条件并刷新
    clearFilterAndRefresh() {
      this.request = { sorting: "", maxResultCount: 50, skipCount: 0 };
      this.name = "";
      this.filterText = "";
      this.getData(this.changeOpt);
    },
    // 分页事件
    showTotalFun() {
      return this.l(
        "GridFooterDisplayText",
        this.pageNumber,
        this.totalPages,
        this.totalItems,
        this.pagerange[0],
        this.pagerange[1]
      );
    },
    // 排序更新data
    updateSortData(newV) {
      let { columnKey, order } = newV;
      this.request.sorting = order ? `${columnKey} ${order}` : "";
      this.getData();
    },
    // 分页
    updatePageChange(newV) {
      let { page, pageSize } = newV;
      this.pageNumber = page;
      this.request.skipCount = (page - 1) * this.request.maxResultCount;
      this.getData();
    },
    updateShowSizeChange(newV) {
      let { current, size } = newV;
      this.pageNumber = 1;
      this.request.maxResultCount = size;
      this.getData();
    },
    // table选择事件
    updateSelectChange(newV) {
      let { selectedRowKeys, selectedRows } = newV;
      this.selectedRowKeys = selectedRowKeys;
    },
    // 初始化需要显示的func btn
    initActionsType() {
      let _this = this;
      let obj = {
        type: "provide",
        isShow: true,
        fns: {
          dropList: [
            {
              granted: true,
              name: this.l("修改"),
              icon: "edit",
              fn: (data) => {
                _this.createOrEdit(data, "edit");
              },
            },
          ],
        },
      };
      this.actionsType = obj;
    },
    // 增加修改查看
    createOrEdit(item, type) {
      const list = [
        {
          label: "税收分类编码",
          value: "taxCategoryCode",
          type: "commonInput",
          disabled: false,
          required: true,
          rules: [{ required: true, message: "请输入" }],
          defaultValue: "",
          span: 20,
          changeFn: () => {},
        },
        {
          label: "税收分类名称",
          value: "taxCategoryName",
          type: "commonInput",
          disabled: false,
          required: true,
          rules: [{ required: true, message: "请输入" }],
          defaultValue: "",
          span: 20,
          changeFn: () => {},
        },
        {
          label: "税率",
          value: "taxRate",
          type: "commonInput",
          disabled: false,
          required: true,
          rules: [{ required: true, message: "请输入" }],
          defaultValue: "",
          span: 20,
          changeFn: () => {},
        },
        {
          label: "产品编码",
          value: "productCode",
          type: "commonInput",
          disabled: false,
          required: true,
          rules: [{ required: true, message: "请输入" }],
          defaultValue: "",
          span: 20,
          changeFn: () => {},
        },
        {
          label: "产品名称",
          value: "productName",
          type: "commonInput",
          disabled: false,
          required: true,
          rules: [{ required: true, message: "请输入" }],
          defaultValue: "",
          span: 20,
          changeFn: () => {},
        },

        {
          label: "发票类型",
          value: "invoiceType",
          type: "commonSelect",
          disabled: false,
          required: true,
          rules: [{ required: true, message: "请选择" }],
          defaultValue: "1",
          defaultSelectList: [
            { label: "增值税普通发票", value: "1" },
            { label: "增值税专用发票", value: "2" },
          ],
          span: 20,
          changeFn: () => {},
        },
      ];
      let reqParams = [];
      // 后续接口不需要id
      if (item && item.id) reqParams.push({ key: "id", value: item.id });
      let otherPrams = {};
      ModalHelper.create(
        ReactModify,
        {
          params: {
            type: type, // edit,preview,create
            data: list,
            reqParams: [
              ...reqParams,
              { key: "organizationUnitId", value: this.id },
            ],
            reqUrl: {
              // getById: '',
              save: `/api/services/app/InvoiceInformational/Save`,
            },
            otherParams: {},
            okBtnTxt: "确定",
            cancelBtnTxt: "关闭",
            initFn: (form) => {
              if (item) {
                this.$nextTick(() => {
                  form.setFieldsValue({
                    taxCategoryCode: item.taxCategoryCode,
                    taxCategoryName: item.taxCategoryName,
                    taxRate: item.taxRate,
                    productCode: item.productCode,
                    productName: item.productName,
                    invoiceType: item.invoiceType.toString(),
                  });
                });
              }
            },
            getItemfn: async (res, form, options) => {
              form.setFieldsValue({ ...res });
              if (options) {
                // ...
              }
            },
            submitfn: async (values, queryParams) => {
              let obj = {};
              queryParams.reqParams.map((item) => {
                obj[item.key] = item.value;
              });
              Object.assign(values, obj);
              // console.log(values)
              try {
                let res = await this.commonService.post({
                  url: queryParams.reqUrl.save,
                  params: {
                    ...values,
                    invoiceType: Number(values.invoiceType),
                  },
                });
                return true;
              } catch (error) {
                return false;
              }
            },
          },
        },
        {
          isChange: true,
          width: "800px",
        }
      ).subscribe((res) => {
        if (res) {
          this.clearFilterAndRefresh();
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.user-container {
  border: 1px solid #e8e8e8;
  margin: 20px;
  padding: 20px;
  .table-edit,
  .table-delete {
    margin-left: 3px;
    i {
      padding: 0 2px;
    }
  }
}
.opeattion-container {
  margin: 20px 0;
}
.pagination {
  margin: 10px auto;
  text-align: right;
}
</style>
